export function parseTimeToMilliseconds(time?: string | null): number | null {
  if (!time) return null;
  const [hoursRaw, minutesRaw, secondsRaw] = time.split(':');
  const hours = Number(hoursRaw);
  const minutes = Number(minutesRaw);
  const seconds = Number(secondsRaw ?? '0');

  if ([hours, minutes, seconds].some((v) => Number.isNaN(v))) {
    return null;
  }

  return ((hours * 60 + minutes) * 60 + seconds) * 1000;
}
